// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 684) return "static/chunks/684-481af5d53f23313e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"181":"e2e367a806f2df7f","260":"2994a508708e8811"}[chunkId] + ".js";
};